"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTheme = void 0;
exports.defaultTheme = {
    primary: "#fff",
    secondary: "#000",
    tertiary: "#ffffff99",
    text_primary: "#000",
    text_secondary: "#fff",
    text_tertiary: "#00000044",
    disableThemeScrollbar: false,
};
